import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import QualValOffering from "@/pages/QualValOffering";

export const Route = createFileRoute("/zh-cn/services/qualification-validation/commissioning")({
  head: () => buildRouteHead("/zh-cn/services/qualification-validation/commissioning"),
  component: QualValOffering,
});

